import styled, { css } from "styled-components"
import Breakpoints from "../shared/breakpoints"
import Typography from "../shared/typography.styles"
import BreakpointImage from "../shared/breakpoint-image"
import { ImageTile } from "../shared/solutions.imagetile"

export const Container = styled.div`
  padding: 64px 0 8px 0;
  @media (min-width: ${Breakpoints.md}) {
    padding: 64px 0;
  }
  @media (min-width: ${Breakpoints.lg}) {
    padding: 96px 0;
  }
`

export const MapImage = styled(BreakpointImage)`
  grid-column: 2 / -2;
  margin-top: 24px;
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.05);

  @media (min-width: ${Breakpoints.md}) {
    margin-top: 32px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / 7;
    margin-top: 0;
    grid-row: 1;
  }
`

export const ContentBlock = styled.div`
  display: flex;
  flex-direction: column;
  ${props => props.styleModifier}
  text-align: center;

  @media (min-width: ${Breakpoints.lg}) {
    text-align: left;
    align-self: center;
  }
`

export const ContentBlockTitle = styled.h2`
  ${Typography.mobileTextStyles.MobileHeadingTwoSemiBold}
  @media (min-width: ${Breakpoints.md}) {
    ${Typography.tabletTextStyles.TabletHeadingTwoSemiBold}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${Typography.desktopTextStyles.HeadingTwoSemiBold}
  }  
`

export const ContentBlockText = styled.p`
  ${Typography.mobileTextStyles.MobileBodyRegular}
  margin-top: 24px;
  @media (min-width: ${Breakpoints.md}) {
    ${Typography.tabletTextStyles.TabletBodyRegular}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${Typography.desktopTextStyles.BodyText18}
    margin-top: 32px;
  }
`

export const ImageTileContainer = styled.div`
  grid-column: 1 / -1;
  margin: 0 -20px;
  overflow: hidden;

  & ${ImageTile} {
    width: 100%;
    height: 110vw;
  }

  & ${ImageTile} p {
    transform: translateY(-8px);
  }

  .slick-dots {
    bottom: 15px;
    color: #fff;
    z-index: 1000;
  }

  .slick-dots li button:before {
    color: #fff;
  }

  @media (min-width: ${Breakpoints.md}) {
    margin: 0 -5px;
    grid-column: 2 / -2;
    display: flex;
    flex-wrap: wrap;

    & ${ImageTile} {
      margin: 5px 5px;
      flex: 0 1 calc(50% - 10px);
      height: 33vw;
    }

    & ${ImageTile} p {
      transform: unset;
    }
  }

  @media (min-width: ${Breakpoints.lg}) {
    padding-bottom: 75px;
    grid-column: -7 / -1;
    & ${ImageTile} {
      :nth-child(2),
      :nth-child(4) {
        transform: translate3D(0, 65px, 0);
      }
      height: 21vw;
      max-height: 300px;
    }
  }
`

export const LinkContainer = styled.div`
  max-width: 282px;
  align-self: center;
  margin-top: 32px;
  @media (min-width: ${Breakpoints.lg}) {
    align-self: flex-start;
  }
`

export const CompanyBlockStyle = css`
  grid-column: 1 / -1;
  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 8 / -1;
  }
`
export const PropertiesBlockStyle = css`
  grid-column: 1 / -1;
  margin-bottom: 32px;
  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 2 / 6;
    margin-bottom: 0;
  }
`

export const Spacer = styled.div`
  grid-column: 1 / -1;
  margin-top: 48px;
  @media (min-width: ${Breakpoints.md}) {
    margin-top: 64px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 96px;
  }
`
